<script>
import {detroLogs} from '../../../../../domain/grv/services'

export default {
  name: 'LogDetroGrvPatio',
  data () {
    return {
      logDetro: null,
      showLog: false,
      logContent: {}
    }
  },
  computed: {
    getDetroTasks () {
      return [
        {
          name: 'Inclusão no pátio',
          checkFcn: this.detroInclusaoExecuted,
          log: this.inclusaoLogs,
          date: this.detroInclusaoExecuted ? (this.detroInclusaoExecuted.dateExecuted ? this.detroInclusaoExecuted.dateExecuted.date : null) : null,
          attemp: this.logDetro.inclusaoLogs
        },
        {
          name: 'Emissão do boleto',
          checkFcn: this.getBoletoLog,
          log: this.geracaoBoletoLogs,
          date: this.getBoletoLog ? (this.getBoletoLog.date ? this.getBoletoLog.date.date : null) : null,
          attemp: this.geracaoBoletoLogs,
          noForce: true
        },
        {
          name: 'Liberação no pátio',
          checkFcn: this.detroLiberacaoExecuted,
          log: this.liberacaoLogs,
          date: this.detroLiberacaoExecuted ? (this.detroLiberacaoExecuted.dateExecuted ? this.detroLiberacaoExecuted.dateExecuted.date : null) : null,
          attemp: this.logDetro.liberacaoLogs
        }
      ]
    },
    detroInclusaoExecuted () {
      let log = this.logDetro.inclusaoLogs
      let executed = null
      log.map(item => {
        if (item.executed) {
          executed = item
        }
      })
      return executed
    },
    detroLiberacaoExecuted () {
      let log = this.logDetro.liberacaoLogs
      let executed = null
      log.map(item => {
        if (item.executed) {
          executed = item
        }
      })
      return executed
    },
    inclusaoLogs () {
      return this.logDetro.logs.filter(log => {
        return log.method === 'incluirVeiculo'
      })
    },
    liberacaoLogs () {
      return this.logDetro.logs.filter(log => {
        return log.method === 'liberarVeiculo'
      })
    },
    geracaoBoletoLogs () {
      return this.logDetro.logs.filter(log => {
        return log.method === 'getBoleto'
      })
    },
    consultaPagamentoLogs () {
      return this.logDetro.logs.filter(log => {
        return log.method === 'consultaPagamento'
      })
    },
    getBoletoLog () {
      {
        let log = this.geracaoBoletoLogs
        let executed = null
        log.map(item => {
          if (Number(item.status) === 1) {
            executed = item
          }
        })
        return executed
      }
    },
    allDetroLogs () {
      return [...this.logDetro.logs, ...this.logDetro.inclusaoLogs, ...this.logDetro.liberacaoLogs]
    }
  },
  mounted () {
    this.detroLogs()
  },
  methods: {
    detroLogs () {
      detroLogs(this.$route.params.id)
        .then((response) => {
          this.logDetro = response.data
          console.log(response)
        })
        .catch((response) => {
          this.$loaderOverlay.hide()
          console.log(response)
        })
    },
    mostraLog (log) {
      this.logContent = log
      this.showLog = true
    }
  }
}
</script>

<template>
  <div v-if="logDetro" class="detro-container m-b">
    <div class="shell-wrap">
      <p class="shell-top-bar">Serviço de Comunicação com o Detro</p>
      <div class="shell-body">
        <table class="table">
          <tr v-for="task in getDetroTasks">
            <td>{{task.name}}</td>
            <td v-if="task.checkFcn">
              <a @click="mostraLog(task.log)">
                <strong>Ok</strong>
                <span class="font-thin">
                      {{moment(task.date).format('L')}} {{moment(task.date).format('LTS')}}
                    </span>
              </a>
            </td>
            <td v-else>
              <strong class="text-danger">Não executado</strong>
              <button @click="mostraLog(task.log)" v-if="Array.isArray(task.attemp) ? task.attemp.length : task.attemp" class="btn btn-xs btn-danger text-white"
                      style="font-family: arial">Tentativas falhas
              </button>
              <!--<button v-if="!task.noForce" class="btn btn-xs text-black" style="font-family: arial">Forçar execução</button>-->
            </td>
          </tr>
          <!--<tr>
            <td>Emissão do boleto</td>
            <td><strong>Ok</strong></td>
          </tr>
          <tr>
            <td>Liberação do pátio</td>
            <td><strong class="text-danger">Não executado</strong>
              <button class="btn btn-xs text-black" style="font-family: arial">Forçar execução</button>
            </td>
          </tr>-->
        </table>
        <div class="m-t">
          <a v-if="allDetroLogs" @click="mostraLog(allDetroLogs)">Existem <strong>{{allDetroLogs.length}} logs</strong> no sistema para esta GRV. Clique para visualizar</a>
        </div>
      </div>
    </div>
    <div class="shell-wrap window" v-if="showLog">
      <div class="shell-top-bar">
        <a @click="showLog = false" class="mclose">x</a>
        Serviço de Comunicação com o Detro
      </div>
      <pre class="shell-body">{{logContent}}</pre>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.detro-container {
  padding: 0 37.5px;

  .table {
    width: 100%;

    td {
      border-bottom: #CCCCCC 1px dashed;
      padding: 6px 0;
    }
  }
}

.window {
  &.shell-wrap {
    position: fixed;
    top: 10px;
    left: 10px;
    right: 10px;
    bottom: 10px;
    z-index: 9998;
    width: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .shell-top-bar {
      position: relative;
      z-index: 9998;
      .mclose{
        position: absolute;
        left: 7px;
        top: 7px;
        width: 12px;
        height: 12px;
        border-radius: 12px;
        background-color: #ea3630;
        color: #ea3630;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;
        font-size: 10px;
        font-weight: normal;
        z-index: 9999;
        line-height: 1;
        text-shadow: none;
        &:hover{
          color: #8b1a16;
        }
      }
    }

    .shell-body {
      flex: 1;
      opacity: 0.9;
      overflow: auto;
      border: none !important;
      border-color: transparent;
      margin: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// LogDetroGrvPatio.vue?d8867fce